import { ClipboardDocumentCheckIcon } from '@heroicons/react/24/outline';
import React, { useState } from 'react';
import Button from './Button';
import CopyToClipboard from './CopyToClipboard';
import Tooltip from './Tooltip';

const CopyableText = ({ text, label }) => {
  const defaultButtonText = 'Copy';
  const [buttonText, setButtonText] = useState(defaultButtonText);

  return (
    <div className="space-y-2">
      {label && <span className="block text-sm font-medium text-gray-700">{label}</span>}

      <div className="flex gap-4 px-4 w-full rounded border-1 border-gray-100 focus:shadow-none bg-gray-50 py-3 ">
        <div className="flex items-center overflow-hidden font-mono text-sm text-gray-900 flex-1">
          <Tooltip label={text}>{text}</Tooltip>
        </div>

        <div className="ml-auto flex items-center">
          <CopyToClipboard
            text={text}
            onCopy={() => {
              setButtonText(
                <div className="flex gap-x-2 items-center">
                  <ClipboardDocumentCheckIcon className="w-5 h-5" />
                  Copied!
                </div>,
              );

              window.setTimeout(() => {
                setButtonText(defaultButtonText);
              }, 1000);
            }}
          >
            <Button appearance="primary">{buttonText}</Button>
          </CopyToClipboard>
        </div>
      </div>
    </div>
  );
};

export default CopyableText;
